//import statement
import React from "react";
import FooterImg from "../assets/footer.png";
import ME from "../assets/magiceden.png";

import { FaDiscord, FaTwitter } from "react-icons/fa";

//functional component
const Footer = () => {
  return (
    <footer>
      <img src={FooterImg} alt="logo" height={60} width={50} />
      <div className="d-flex justify-content-center my-4">
        <a href=" https://discord.gg/thefracture" target="_blank">
          {" "}
          <FaDiscord color="white" className="mx-1" size={25} />{" "}
        </a>
        <a href="https://twitter.com/TheFracture_" target="_blank">
          {" "}
          <FaTwitter color="white" className="mx-1" size={25} />{" "}
        </a>
        <a href="https://magiceden.io/creators/the_fracture" target="_blank">
          {" "}
          <img src={ME} className="mx-1" alt="logo" />{" "}
        </a>
      </div>
      <p>© 2022 The Fracture | All rights reserved</p>
    </footer>
  );
};
export default Footer;
